import React, { ReactElement } from 'react';
import { RemoteContact } from '../types';
import EmailField from './emai-field';
import PhoneField from './phone-field';

export default function ActivityItem(props: RemoteContact): ReactElement {
  return (
    <div className="ts-activity-item-row content-bg views-row">
      <div className="ts-activity-item-row-content">
        <div className="ts-activity-item-row-title">
          {props.firstname} {props.surname}
        </div>
        <div className="ts-activity-item-row-text">
          <div>{props.role}</div>
          <EmailField email={props.email} />
          <PhoneField phone={props.phone} />
        </div>
        <div className="ts-activity-item-row-footer clearfix">
          <div className="ts-activity-item-row-social-info" />
          <div className="ts-activity-item-row-date" />
        </div>
      </div>
      <div className="ts-activity-item-row-image activities no-image" />
    </div>
  );
}
